import { Paragraph } from '@/components';
import { ButtonType, IImageProp, WEB_APP_JP_SIGN_UP_URL } from '@/constants';
import React, { ReactNode } from 'react';
import { NewsItemProp } from '../news/news-item';
import { NewsType } from '../news/tags';
import * as styles from './index.module.less';

// meeting tools logo
export const MeetingToolsLogo: IImageProp[] = [
  {
    src: 'https://a.storyblok.com/f/159374/104x39/02c79989b1/zoom.svg',
    alt: 'Zoom logo',
  },
  {
    src: 'https://a.storyblok.com/f/159374/141x41/f1da8ad014/google-meet.svg',
    alt: 'Google Meet logo',
  },
  {
    src: 'https://a.storyblok.com/f/159374/166x40/a7cab7fef0/image-homepage-hero-banner-platform-microsoft-teams.svg',
    alt: 'Microsoft teams logo',
  },
];

// honor list
export const HonorList = [
  {
    src: 'https://a.storyblok.com/f/159374/238x75/de526b099e/app-of-the-day.svg',
    alt: '今日のアプリ APP STORE',
  },
  {
    src: 'https://a.storyblok.com/f/159374/214x76/01fd3b4ac7/number-of-people.svg',
    alt: '累積ユーザー　100万人',
  },
  {
    src: 'https://a.storyblok.com/f/159374/212x76/e0dcfcb762/image-homepage-hero-banner-award-03-client-amount.svg',
    alt: '導入企業　500社以上',
  },
  {
    src: 'https://a.storyblok.com/f/159374/189x76/74e03ce75b/language-accuracy.svg',
    alt: '文字起こし精度　98%',
  },
];

// company logos
export const companyLogoList = [
  {
    src: 'https://a.storyblok.com/f/159374/364x128/a133eff58b/customer-logo-homepage-micoworks.png',
    alt: 'Micoworks',
  },
  {
    src: 'https://a.storyblok.com/f/159374/224x128/544cfc9fb1/customer-logo-homepage-bexide.png',
    alt: 'BeXide',
  },
  {
    src: 'https://a.storyblok.com/f/159374/144x128/91c363420d/customer-logo-homepage-bni.png',
    alt: 'BNI',
  },
  {
    src: 'https://a.storyblok.com/f/159374/192x128/6bb6ffd160/customer-logo-homepage-ptna.png',
    alt: 'PTNA',
  },
  {
    src: 'https://a.storyblok.com/f/159374/128x128/92701f28bc/customer-logo-homepage-yec.png',
    alt: 'Yec',
  },
  {
    src: 'https://a.storyblok.com/f/159374/300x95/1679512c19/.svg',
    alt: '山形県',
  },
  {
    src: 'https://a.storyblok.com/f/159374/288x128/4b6ccc97a4/customer-logo-homepage-bluememe.png',
    alt: 'bluememe',
  },
  {
    src: 'https://a.storyblok.com/f/159374/272x64/3f0f0299ba/grammarly.svg',
    alt: 'grammarly',
  },
  {
    src: 'https://a.storyblok.com/f/159374/198x64/3dfccb018d/omron.svg',
    alt: 'omron',
  },
  {
    src: 'https://a.storyblok.com/f/159374/85x64/d756bd3e6c/pwc.svg',
    alt: 'pwc',
  },
  {
    src: 'https://a.storyblok.com/f/159374/92x64/b6a6f12959/salesforce.svg',
    alt: 'salesforce',
  },
];

// privacy authorization logo
export const PrivacyAuthLogoList = [
  {
    src: 'https://a.storyblok.com/f/159374/65x65/3b34983db2/gdpr.svg',
    alt: 'GDPR（EU一般データ 保護規則）',
  },
  {
    src: 'https://a.storyblok.com/f/159374/65x65/85c7ef150b/soc-2.svg',
    alt: 'SOC 2 Type II',
  },
  {
    src: 'https://a.storyblok.com/f/159374/61x65/d0f91b33ca/ccpa.svg',
    alt: 'CCPA（カリフォルニア州新プライバシー法）',
  },
  {
    src: 'https://a.storyblok.com/f/159374/62x65/66727c1d1a/ssl.svg',
    alt: 'SSL暗号化（Secure Sockets Layer）',
  },
  {
    src: 'https://a.storyblok.com/f/159374/64x65/cb88233697/image-homepage-security-05-appi-jp.svg',
    alt: 'APPI（日本個人情報保護法）',
  },
];

// notta solve problems
export interface IProblemsList {
  problem: React.ReactNode;
  withPicture: IImageProp;
  solution: React.ReactNode;
}

export const ProblemsList = [
  {
    problem: (
      <>
        議事録作成に
        <wbr />
        手間がかかる
      </>
    ),
    withPicture: {
      src: 'https://a.storyblok.com/f/159374/641x481/d1a7e3071d/image.png',
      alt: '議事録作成に悩む男',
    },
    solution: (
      <p>
        会議
        <wbr />
        終了
        <wbr />と<wbr />
        同時
        <wbr />に<wbr />
        議事録
        <wbr />も<wbr />
        完成
      </p>
    ),
  },
  {
    problem: (
      <>
        言った
        <wbr />
        言わない
        <wbr />
        問題
      </>
    ),
    withPicture: {
      src: 'https://a.storyblok.com/f/159374/640x481/b35828dd1a/image-1.png',
      alt: '言った言わない問題',
    },
    solution: (
      <p>
        蓄積した
        <wbr />
        音声・
        <wbr />
        テキストデータ
        <wbr />の<wbr />
        検索
      </p>
    ),
  },
  {
    problem: <>情報の再利用・共有が困難</>,
    withPicture: {
      src: 'https://a.storyblok.com/f/159374/641x481/2009609158/image-2.png',
      alt: '情報共有',
    },
    solution: (
      <p>
        録音
        <wbr />・<wbr />
        画面
        <wbr />
        録画
        <wbr />
        ・文字
        <wbr />
        データをオンライン
        <wbr />で<wbr />
        共有
        <wbr />
      </p>
    ),
  },
];

// Notta can do
export const EditShareInfo = {
  title: (
    <>
      <span className={styles.home_page_notta_can_do_number}>①</span>多様
      <wbr />な<wbr />
      文字起こし
      <wbr />
      方法
      <wbr />と<wbr />
      便利な
      <wbr />
      編集・
      <wbr />
      共有機能
    </>
  ),
  featureListGroup: [
    {
      title: '文字起こし・録画',
      featureList: [
        <>リアルタイム文字起こし</>,
        <>外部データ・音声ファイルの文字起こし</>,
        <>Webページの画面収録</>,
        <>Web会議の自動文字起こし・録画</>,
      ],
    },
    {
      title: '編集',
      featureList: [<>タグ付けとメモ</>, <>発言者自動識別・名前変更</>, <>テキスト編集</>],
    },
    {
      title: '共有',
      featureList: [
        <>エクスポート</>,
        <>
          共有リンクの発行（パスワード保護）<a href="/pricing">すべての機能を見る -&gt; </a>
        </>,
      ],
    },
  ],
  description: (
    <>
      <Paragraph isWordKeepAll>
        リアルタイム
        <wbr />で<wbr />の<wbr />
        文字起こし、
        <wbr />
        音声ファイル
        <wbr />の<wbr />
        文字起こし、
        <wbr />
        Web会議
        <wbr />の<wbr />
        自動文字起こし
        <wbr />と<wbr />
        録画
        <wbr />が<wbr />
        できます。
        <wbr /> 重要な部分
        <wbr />に<wbr />
        タグ
        <wbr />を<wbr />
        付けたり
        <wbr />
        メモ
        <wbr />を<wbr />
        取ったり
        <wbr />が<wbr />
        でき、
        <wbr />
        気になる
        <wbr />
        部分
        <wbr />は<wbr />
        すぐに
        <wbr />
        再生して
        <wbr />
        実際
        <wbr />の<wbr />
        音声
        <wbr />と<wbr />
        テキスト
        <wbr />を<wbr />
        確認
        <wbr />
        できます。
      </Paragraph>
      <Paragraph isWordKeepAll>
        さらに、
        <wbr />
        Notta
        <wbr />
        には
        <wbr />
        共有機能
        <wbr />が<wbr />
        あり、
        <wbr />
        文字起こし
        <wbr />の<wbr />
        結果
        <wbr />や<wbr />
        会議録画
        <wbr />を<wbr />
        他のユーザー
        <wbr />と<wbr />
        共有リンク
        <wbr />を<wbr />
        使って
        <wbr />
        共有
        <wbr />
        できます。
      </Paragraph>
    </>
  ),
  withPic: {
    src: 'https://a.storyblok.com/f/159374/1080x808/1aa1b6b7df/feature-1.png',
    alt: '音声入力・便利な文字起こしデータ編集と共有機能',
  },
  formatGroup: [
    {
      title: '音声対応形式',
      list: ['WAV', 'MP3', 'M4A', 'CAF', 'AIFF'],
    },
    {
      title: '動画対応形式',
      list: ['AVI', 'MP4', 'RMVB', 'FLV', 'MOV', 'WMV'],
    },
    {
      title: 'エクスポート',
      list: ['WAV', 'DOCX', 'TXT', 'PDF', 'SRT（字幕）', 'XLSX（エクセル）'],
    },
  ],
};

type Paragraph = {
  type: 'paragraph';
  text: string | React.ReactNode;
};

type Ul = {
  type: 'ul';
  text: (string | ReactNode)[];
};

type DescriptionItem = Paragraph | Ul;

type TransWorkspace = {
  withPic: IImageProp;
  title: React.ReactNode;
  description: DescriptionItem[];
};

export const TransWorkspaceList: TransWorkspace[] = [
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/1000x752/83940919e1/feature-2.png',
      alt: '音声・文字起こしデータ解析',
    },
    title: (
      <>
        ②音声·
        <wbr />
        文字起こしデータ
        <wbr />の<wbr />
        解析
        <wbr />で<wbr />
        新たな
        <wbr />
        価値
        <wbr />を<wbr />
        創出
      </>
    ),
    description: [
      {
        type: 'paragraph',
        text: (
          <>
            一言一句
            <wbr />
            まで
            <wbr />
            極めて
            <wbr />
            高い精度
            <wbr />で<wbr />
            再現し、
            <wbr />
            商談
            <wbr />の<wbr />
            議論
            <wbr />を<wbr />
            深めたり
            <wbr />
            分析
            <wbr />や<wbr />
            考察
            <wbr />を<wbr />
            行ったりする
            <wbr />
            ために
            <wbr />
            通常
            <wbr />
            必要な
            <wbr />
            情報処理
            <wbr />に<wbr />
            かかる時間
            <wbr />と<wbr />
            コスト
            <wbr />を<wbr />
            大幅に
            <wbr />
            削減する
            <wbr />
            こと
            <wbr />が<wbr />
            できます。
            <wbr />
            情報
            <wbr />の<wbr />
            可視性
            <wbr />を<wbr />
            高め、
            <wbr />
            相互信頼
            <wbr />を<wbr />
            醸成する
            <wbr />
            基盤
            <wbr />と<wbr />
            なります。
          </>
        ),
      },
      {
        type: 'ul',
        text: [
          <>
            <strong>ChatGPTを使ったAI要約機能。</strong>
            <span style={{ fontSize: '12px', color: '#b0b7bf' }}>
              ※提供された情報はすべて暗号化された上で、AIによる学習の対象とはなりません。
            </span>
          </>,
          '検索機能：重要な音声・画面記録の瞬間をすぐに振り返ることができます。',
        ],
      },
    ],
  },
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/1000x752/966895815e/feature-3.png',
      alt: 'チームワークスペース',
    },
    title: <>③チームワークスペース</>,
    description: [
      {
        type: 'paragraph',
        text: (
          <>
            Nottaチームワークスペース
            <wbr />
            とは、
            <wbr />
            多人数
            <wbr />で<wbr />
            情報
            <wbr />の<wbr />
            共同管理
            <wbr />や<wbr />
            編集
            <wbr />を<wbr />
            行える
            <wbr />
            Nottaワークスペース
            <wbr />の<wbr />
            こと
            <wbr />
            です。
            <wbr />
            議事録
            <wbr />や<wbr />
            録画
            <wbr />の<wbr />
            一括共有
            <wbr />や<wbr />
            管理、
            <wbr />
            権限
            <wbr />の<wbr />
            振り分け
            <wbr />
            など
            <wbr />を<wbr />
            チーム利用者
            <wbr />の<wbr />中<wbr />で<wbr />
            行えます。
          </>
        ),
      },
      {
        type: 'paragraph',
        text: (
          <>
            また、個々のチームのニーズに合わせて柔軟にカスタマイズが可能です。データアクセスやメンバーの権限管理を簡単に行えるほか、利用状況レポートやIPアドレス制限により、セキュリティも確保されます。外部共有の制限機能を活用することで、情報漏えいのリスクも軽減できます。チーム全体で重要な情報を効率的に共有・活用し、生産性向上に貢献しましょう。
          </>
        ),
      },
      {
        type: 'ul',
        text: [
          'チームワークスペースの作成',
          'データアクセスとメンバーの権限管理',
          '利用状況レポート',
          '外部共有の制限',
          'IPアドレス制限',
        ],
      },
    ],
  },
];

// Useful Example
export interface IUsefulExample {
  withPic: IImageProp;
  title: string | React.ReactNode;
  desc: string | React.ReactNode;
}

export const UsefulExamplesList: IUsefulExample[] = [
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/160x120/324b9e31db/image-homepage-other-features-01.svg',
      alt: 'カスタム単語登録',
    },
    title: (
      <>
        カスタム
        <wbr />
        単語登録
      </>
    ),
    desc: (
      <>
        専門用語や頻繁に使用する
        <wbr />
        会社名・人名をカスタム辞書に登録することで、文字起こしの
        <wbr />
        精度を向上させ、編集作業が
        <wbr />
        効率化されます。
      </>
    ),
  },
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/160x120/a31952ec3f/image-homepage-other-features-02.svg',
      alt: '多言語テキスト翻訳',
    },
    title: (
      <>
        多言語テキスト
        <wbr />
        翻訳
      </>
    ),
    desc: (
      <>
        文字起こし結果を42
        <wbr />
        言語に対応した翻訳が
        <wbr />
        可能で、英語と日本語の同時
        <wbr />
        変換もできます。国際会議や研修のサポートに活用できます。
      </>
    ),
  },
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/320x240/8f0cbe5a31/type-youtube-google-drive-dropbox.png',
      alt: 'クイックリンク対応',
    },
    title: (
      <>
        クイックリンク
        <wbr />
        対応
      </>
    ),
    desc: (
      <>
        Dropbox、Google
        <wbr />
        ドライブのリンクをNottaに貼り付ける
        <wbr />
        だけで、手軽に文字起こしを実行
        <wbr />
        できます。
      </>
    ),
  },
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/160x120/09ec68482c/image-homepage-other-features-04-chrome.svg',
      alt: 'Chrome拡張機能',
    },
    title: (
      <>
        Chrome
        <wbr />
        拡張機能
      </>
    ),
    desc: (
      <>
        <a href="https://www.notta.ai/blog/notta-audio-clipper-extension-guide" target="_blank" rel="noreferrer">
          Notta Chrome拡張機能
        </a>
        を利用して、Chrome内の音声を直接テキスト化できます。また、アプリ内で結果の編集・閲覧が可能です。
      </>
    ),
  },
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/160x120/6ce9a9f73a/image-homepage-other-features-05.svg',
      alt: '自動校正機能',
    },
    title: (
      <>
        自動校正
        <wbr />
        機能
      </>
    ),
    desc: (
      <>
        誤字や違和感のあるテキストに
        <wbr />
        赤線が引かれ、修正が必要な箇所が自動で
        <wbr />
        表示されます。
      </>
    ),
  },
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/160x123/e618e77b45/image-homepage-other-features-06.svg',
      alt: '発言者名の変更',
    },
    title: (
      <>
        発言者名の
        <wbr />
        変更
      </>
    ),
    desc: (
      <>
        発言者の特定と名前変更が自動で行われ、
        <wbr />
        会話の整理が容易になります。
      </>
    ),
  },
];

// import case
export interface IImportCase {
  link: string;
  withPic: IImageProp;
  companyLogo: IImageProp;
  companyName: string;
  companyTag: string[];
  title: string | React.ReactNode;
  desc: string;
}

export const ImportCaseList: IImportCase[] = [
  {
    link: '/cases/yachiyo',
    withPic: {
      src: 'https://a.storyblok.com/f/159374/747x576/38f6ed4022/image-1.png',
      alt: '導入事例　八千代エンジニヤリング株式会社',
    },
    companyLogo: {
      src: 'https://a.storyblok.com/f/159374/64x65/591dcb62ed/customer.svg',
      alt: '八千代エンジニヤリング株式会社',
    },
    companyName: '八千代エンジニヤリング株式会社',
    companyTag: ['建設コンサルタント', '1000-1500人'],
    title: (
      <>
        Notta
        <wbr />で<wbr />
        会議
        <wbr />
        効率
        <wbr />
        大幅
        <wbr />
        UP！
        <wbr />
        議事録
        <wbr />を<wbr />
        終了後
        <wbr />
        でもう
        <wbr />
        議事録
      </>
    ),
    desc: 'DX推進の一環として、議事録作成ツールNottaを導入。社内外でも使えることで、会議の効率が大幅に向上しました。終了後でも議事録を作成できるため、スムーズな進行が実現します。',
  },
  {
    link: '/cases/ma-design',
    withPic: {
      src: 'https://a.storyblok.com/f/159374/748x576/838acb37c8/image-2.png',
      alt: '導入事例　株式会社M＆Aデザイン',
    },
    companyLogo: {
      src: 'https://a.storyblok.com/f/159374/65x65/3afc96c899/customer-1.svg',
      alt: '株式会社M＆Aデザイン',
    },
    companyName: '株式会社M＆Aデザイン',
    companyTag: ['Webサイト制作・運用', '1-10人'],
    title: (
      <>
        Notta
        <wbr />で<wbr />
        Web
        <wbr />
        会議
        <wbr />も<wbr />
        スムーズ
        <wbr />
        に！
        <wbr />
        議事録
        <wbr />と<wbr />
        備忘録
        <wbr />
        を兼ねた
        <wbr />
        顧客
        <wbr />
        対応
      </>
    ),
    desc: 'Nottaを使ってリモート会議の録音や文字起こし作業を行い、その後で議事録として顧客に共有ができます。時間節約になると同時に、備忘録として振り返ることができるので、顧客対応がスムーズになります。',
  },
  {
    link: '/cases/public-servant',
    withPic: {
      src: 'https://a.storyblok.com/f/159374/747x576/3d7e74aa4d/image-3.png',
      alt: '導入事例　公務員試験に合格した団体職員',
    },
    companyLogo: {
      src: 'https://a.storyblok.com/f/159374/65x65/2574e46350/customer-3.svg',
      alt: '個人ユーザー',
    },
    companyName: '個人ユーザー',
    companyTag: ['団体職員'],
    title: (
      <>
        Notta
        <wbr />で<wbr />
        面接力を
        <wbr />
        倍増させる！模擬
        <wbr />
        面接の
        <wbr />
        録音を
        <wbr />
        テキスト化
      </>
    ),
    desc: 'Nottaを使って模擬面接の録音を文字起こしし、何度も読み返して復習することで練習効率がアップします。面接力を倍増させることができるため、就職活動やキャリアアップに役立ちます。',
  },
];

// media public result
export const MediaLogoList: IImageProp[] = [
  {
    src: 'https://a.storyblok.com/f/159374/282x128/f78a227d91/media-logo-homepage-dime.png',
    alt: 'DIME',
  },
  {
    src: 'https://a.storyblok.com/f/159374/332x128/710f7459ec/media-logo-homepage-daily-gadget.png',
    alt: 'デイリーガジェット',
  },
  {
    src: 'https://a.storyblok.com/f/159374/322x128/4d549a5f0f/media-logo-homepage-itmedia.png',
    alt: 'ITMedia',
  },
  {
    src: 'https://a.storyblok.com/f/159374/454x128/68efac5112/media-logo-homepage-hacker.png',
    alt: '会議HACK',
  },
  {
    src: 'https://a.storyblok.com/f/159374/314x128/3f043213fa/media-logo-homepage-ascii.png',
    alt: 'ASCII.jp (アスキー)',
  },
  {
    src: 'https://a.storyblok.com/f/159374/256x124/4779240929/media-logo-homepage-cnet-japan.png',
    alt: 'CNet Japan',
  },
  {
    src: 'https://a.storyblok.com/f/159374/340x136/669d54a57e/media-logo-homepage-voix.png',
    alt: 'VOIX (ボイス)',
  },
  {
    src: 'https://a.storyblok.com/f/159374/103x59/1cd8f6d3b7/customer.svg',
    alt: 'Appliv',
  },
];

export const NEWS_LIST: NewsItemProp[] = [
  {
    date: '2023-05-31 10:15',
    link: 'news/release/202305311015',
    title: '『Notta』に「AI要約機能」が搭載されました',
    type: NewsType.RELEASE,
  },
  {
    date: '2023-03-10 10:15',
    link: 'news/release/202303101015',
    title: 'Nottaがスケジュール機能をリリース',
    type: NewsType.RELEASE,
  },
  {
    date: '2023-03-15 12:01',
    link: 'news/media/202303081015',
    title: 'Liskulに掲載されました',
    type: NewsType.MEDIA,
  },
  {
    date: '2023-02-12 10:15',
    link: 'news/info/202302121015',
    title: 'SOC 2 Type II保証報告書を受領',
    type: NewsType.INFO,
  },
];

// bottom cta
export interface IBottomCtaData {
  withPic: IImageProp;
  desc: string | ReactNode;
  tips?: string;
  btn: {
    type: 'default' | 'primary' | 'link';
    text: string;
    link: string;
    id?: string;
  };
}

export const BottomCtaData: IBottomCtaData[] = [
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/120x120/a421527043/image-homepage-cta-01-transcription.svg',
      alt: '音声を文字に変換',
    },
    desc: '議事録作成の時間短縮や文字起こしの手間削減、聞き逃し防止や復習など、Nottaの活用シーンは様々です。',
    btn: {
      type: 'primary',
      text: 'いますぐ無料で始める',
      link: WEB_APP_JP_SIGN_UP_URL,
      id: 'home-page-bottom-cta-to-sign-up-btn',
    },
  },
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/120x120/f4371088f2/image-homepage-cta-02-contact.svg',
      alt: '導入のお問い合わせ',
    },
    desc: '導入に関するご質問やご要望、製品資料やお見積もり等、お気軽にお問い合わせください。',
    btn: {
      type: 'default',
      text: '相談する',
      link: '/about',
      id: 'home-page-bottom-cta-to-about-page-btn',
    },
  },
  {
    withPic: {
      src: 'https://a.storyblok.com/f/159374/120x120/6b1ab010df/image-homepage-cta-03-special-discount.svg',
      alt: '割引サービス',
    },
    desc: (
      <>
        <a href="https://support.notta.ai/hc/ja/articles/8450474004507">聴覚障がい</a>
        のある方、<a href="/education-plan">教員および在籍学生向け</a>に、50%OFFの割引サービスをご提供しております。
      </>
    ),
    btn: {
      type: 'link',
      text: '詳しくはこちら',
      link: 'https://support.notta.ai/hc/ja/articles/9472303665819',
      id: 'home-page-bottom-cta-to-support-btn',
    },
  },
];

// pricing data
export enum PlanType {
  FREE,
  PRO,
  TEAMS,
}

export interface PricePlanType {
  dataGtm: string;
  type: PlanType;
  name: string;
  desc: string;
  tag?: string;
  averagePrice: {
    en: {
      month: number | string;
      year: number | string;
    };
    ja: {
      month: number | string;
      year: number | string;
    };
  };
  accountTag?: string;
  priceDesc: string;
  priceUnit?: {
    en: string;
    ja: string;
  };
  upgradeBtn: {
    text: string;
    btnType: ButtonType;
    link: string;
  };
  featureDesc: string;
  featureList: (string | React.ReactNode)[];
}

export const FreePlanInfo: PricePlanType = {
  dataGtm: 'home-page-pricing-free-plan-btn',
  type: PlanType.FREE,
  name: '無料プラン',
  desc: 'Nottaを無料でお試しいただける方向けのプランです。',
  averagePrice: {
    en: {
      month: '',
      year: '',
    },
    ja: {
      month: '',
      year: '無料',
    },
  },
  priceDesc: 'クレジットカードは必要ありません',
  upgradeBtn: {
    text: '無料ではじめる',
    btnType: 'default',
    link: 'https://www.app.notta.ai/signup',
  },
  featureDesc: 'subscribe_free_interest_text',
  featureList: [
    '月に120分の文字起こし時間が利用可能',
    'subscribe_feature_title_11',
    'subscribe_organize_sync_across_devices',
    'subscribe_feature_live_screen_recording',
    'subscribe_interest_speaker_identification',
  ],
};
export const ProPlanInfo: PricePlanType = {
  dataGtm: 'home-page-pricing-pro-plan-btn',
  type: PlanType.PRO,
  name: 'プレミアム',
  desc: '十分な文字起こし時間と多様な機能を利用したい個人向けのプランです。',
  averagePrice: {
    en: {
      month: '',
      year: '',
    },
    ja: {
      month: 2000,
      year: 1200,
    },
  },
  accountTag: '40％OFF',
  priceDesc: 'subscribe_card_pro_payment_period_annually',
  priceUnit: {
    en: '',
    ja: '円/月',
  },
  upgradeBtn: {
    text: 'subscribe_subscribe_page_action_button_name',
    btnType: 'primary',
    link: 'https://app.notta.ai?from=official&subscribe_type=pro',
  },
  featureDesc: 'subscribe_pro_interest_text',
  featureList: [
    '月に1800分の文字起こし時間が利用可能',
    'subscribe_feature_title_1',
    'subscribe_pro_interest_import_media_files',
    'subscribe_pro_cloud_drive_transcription',
    'subscribe_transcription_notta_bot',
    'subscribe_transcription_chrome_extension',
    'subscribe_pro_interest_export_files',
    'subscribe_pro_interest_vocabulary',
  ],
};
export const TeamsPlanInfo: PricePlanType = {
  dataGtm: 'home-page-pricing-teams-plan-btn',
  type: PlanType.TEAMS,
  name: 'ビジネス',
  desc: '一つのワークスペースで、共同で文字起こしを行いたい小規模法人向けのプランです。',
  tag: '初期費用なし',
  averagePrice: {
    en: {
      month: '',
      year: '',
    },
    ja: {
      month: 8280,
      year: 6210,
    },
  },
  accountTag: '最大25％OFF',
  priceDesc: 'subscribe_card_team_payment_period_annually',
  priceUnit: {
    en: '',
    ja: '円/月',
  },
  upgradeBtn: {
    text: 'subscribe_team_plan_upgrade_btn',
    btnType: 'primary',
    link: 'https://app.notta.ai?from=official&subscribe_type=team',
  },
  featureDesc: 'subscribe_team_interest_text',
  featureList: [
    <>
      月に2400分の文字起こし時間、２ユーザーから
      <span className={styles.home_page_pricing_feature_item_desc}>（時間とユーザーが変動可能）</span>
    </>,
    'subscribe_team_interest_seats_desc',
    'subscribe_interest_team_management_member',
    'subscribe_team_interest_file_management',
    'subscribe_feature_meeting_record_video',
    'subscribe_feature_video_playback',
  ],
};

// statistics
export const STATISTICS_DATA = [
  {
    src: 'https://a.storyblok.com/f/159374/118x76/694198ffb9/app-of-the-day.svg',
    alt: '今日のアプリ APP STORE',
  },
  {
    src: 'https://a.storyblok.com/f/159374/155x81/3dfbfeffb8/100.svg',
    alt: '累積ユーザー　100万人',
  },
  {
    src: 'https://a.storyblok.com/f/159374/132x76/03723b811b/number-of-companies.svg',
    alt: '導入企業　500社以上',
  },
  {
    src: 'https://a.storyblok.com/f/159374/115x81/efe2c063bc/language-accuracy.svg',
    alt: '文字起こし精度　98%',
  },
];

// statistics
export const STATISTICS_DATA_HERO = [
  {
    src: 'https://a.storyblok.com/f/159374/118x76/694198ffb9/app-of-the-day.svg',
    alt: '今日のアプリ APP STORE',
  },
  {
    src: 'https://a.storyblok.com/f/159374/149x76/5460838514/number-of-people.svg',
    alt: '累積ユーザー　100万人',
  },
  {
    src: 'https://a.storyblok.com/f/159374/132x76/03723b811b/number-of-companies.svg',
    alt: '導入企業　500社以上',
  },
  {
    src: 'https://a.storyblok.com/f/159374/122x76/1a1bd99e1d/language-accuracy.svg',
    alt: '文字起こし精度　98%',
  },
];
